// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDgL0PVDz75uDdCftdSAyxEHm8cUYyvQhI",
  authDomain: "livesta-4e9e3.firebaseapp.com",
  projectId: "livesta-4e9e3",
  storageBucket: "livesta-4e9e3.firebasestorage.app",
  messagingSenderId: "199536566677",
  appId: "1:199536566677:web:15e17454097213821bd69c",
  measurementId: "G-V46JDJR5HZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics };